import { ContactStore } from './types.ts'

export const initialContactState: ContactStore = {
  success: false,
  loading: false,
  error: null,
  initialLoaded: false,
  selected: {
    account: '',
    billingContract: '',
    opportunity: ''
  },
  contact: undefined,
  accounts: {},
  billingContracts: {},
  opportunities: {},
  ignoredBillingContracts: [],
  contactEmails: {},
  myContact: {
    error: null,
    loading: false,
    success: false
  },
  contactByEmail: {
    error: null,
    loading: false,
    success: false,
    errorData: []
  }
}
